import { AdvancedTypeOption, advancedTypes } from '../../domain'

export function useAdvancedTypes(): Record<string, AdvancedTypeOption[]> {
  return {
    advancedTypes,
  }
}
